export const types = {
    INVESTOR_TEST_PRE_REQUEST: "investmentfunds/INVESTOR_TEST_PRE_REQUEST",
    INVESTOR_TEST_PRE_SUCCESS: "investmentfunds/INVESTOR_TEST_PRE_SUCCESS",
    INVESTOR_TEST_PRE_FAILURE: "investmentfunds/INVESTOR_TEST_PRE_FAILURE",

    INVESTOR_TEST_SEND_REQUEST: "investmentfunds/INVESTOR_TEST_SEND_REQUEST",
    INVESTOR_TEST_SEND_SUCCESS: "investmentfunds/INVESTOR_TEST_SEND_SUCCESS",
    INVESTOR_TEST_SEND_FAILURE: "investmentfunds/INVESTOR_TEST_SEND_FAILURE",

    FIRST_INVESTOR_TEST: "investmentfunds/FIRST_INVESTOR_TEST",

    INVESTOR_PROFILE_READ_REQUEST: "investmentfunds/INVESTOR_PROFILE_READ_REQUEST",
    INVESTOR_PROFILE_READ_SUCCESS: "investmentfunds/INVESTOR_PROFILE_READ_SUCCESS",
    INVESTOR_PROFILE_READ_FAILURE: "investmentfunds/INVESTOR_PROFILE_READ_FAILURE",

    DASHBOARD_PRE_REQUEST: "investmentfunds/DASHBOARD_PRE_REQUEST",
    DASHBOARD_PRE_SUCCESS: "investmentfunds/DASHBOARD_PRE_SUCCESS",
    DASHBOARD_PRE_FAILURE: "investmentfunds/DASHBOARD_PRE_FAILURE",

    ACCOUNT_OFFICER_CONTACT_REQUEST: "investmentfunds/ACCOUNT_OFFICER_CONTACT_REQUEST",
    ACCOUNT_OFFICER_CONTACT_SUCCESS: "investmentfunds/ACCOUNT_OFFICER_CONTACT_SUCCESS",
    ACCOUNT_OFFICER_CONTACT_FAILURE: "investmentfunds/ACCOUNT_OFFICER_CONTACT_FAILURE",

    ACCOUNTS_LIST_REQUEST: "investmentfunds/ACCOUNTS_LIST_REQUEST",
    ACCOUNTS_LIST_SUCCESS: "investmentfunds/ACCOUNTS_LIST_SUCCESS",
    ACCOUNTS_LIST_FAILURE: "investmentfunds/ACCOUNTS_LIST_FAILURE",

    ACCOUNTS_ADD_PRE_REQUEST: "investmentfunds/ACCOUNTS_ADD_PRE_REQUEST",
    ACCOUNTS_ADD_PRE_SUCCESS: "investmentfunds/ACCOUNTS_ADD_PRE_SUCCESS",
    ACCOUNTS_ADD_PRE_FAILURE: "investmentfunds/ACCOUNTS_ADD_PRE_FAILURE",

    ACCOUNTS_ADD_SEND_REQUEST: "investmentfunds/ACCOUNTS_ADD_SEND_REQUEST",
    ACCOUNTS_ADD_SEND_SUCCESS: "investmentfunds/ACCOUNTS_ADD_SEND_SUCCESS",
    ACCOUNTS_ADD_SEND_FAILURE: "investmentfunds/ACCOUNTS_ADD_SEND_FAILURE",

    ACCOUNT_SET_ACCOUNT_DATA: "investmentfunds/ACCOUNT_SET_ACCOUNT_DATA",

    DOWNLOAD_ACCOUNT_TERMS_REQUEST: "investmentfunds/DOWNLOAD_ACCOUNT_TERMS_REQUEST",

    ACCOUNTS_ADD_DELETE_DOC_REQUEST: "investmentfunds/ACCOUNTS_ADD_DELETE_DOC_REQUEST",
    ACCOUNTS_ADD_DELETE_DOC_SUCCESS: "investmentfunds/ACCOUNTS_ADD_DELETE_DOC_SUCCESS",
    ACCOUNTS_ADD_DELETE_DOC_FAILURE: "investmentfunds/ACCOUNTS_ADD_DELETE_DOC_FAILURE",

    ACCOUNTS_ADD_UPLOAD_DOC_REQUEST: "investmentfunds/ACCOUNTS_ADD_UPLOAD_DOC_REQUEST",
    ACCOUNTS_ADD_UPLOAD_DOC_SUCCESS: "investmentfunds/ACCOUNTS_ADD_UPLOAD_DOC_SUCCESS",
    ACCOUNTS_ADD_UPLOAD_DOC_FAILURE: "investmentfunds/ACCOUNTS_ADD_UPLOAD_DOC_FAILURE",

    ACCOUNTS_DOCUMENT_UPLOAD_RESET: "investmentfunds/ACCOUNTS_DOCUMENT_UPLOAD_RESET",
};

export const INITIAL_STATE = {
    fetching: false,
    fetchingSubmit: false,
    questions: [],
    investorProfile: null,
    lastTestDate: null,
    expired: false,
    accountsOfficer: null,
    deposits: null,
    fci: null,
    bac: null,
    accountsInfo: null,
    accountData: null,
    fciAccount: null,
    bonusesAccount: null,
    route: null,
    firstTest: false,
    documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },
    testUpdateMessage: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        questions,
        investorProfile,
        testUpdateMessage,
        lastTestDate,
        expired,
        accountsOfficer,
        deposits,
        fci,
        bac,
        accountsInfo,
        accountData,
        fciAccount,
        bonusesAccount,
        documentToUploadRequest,
        documentCode,
    } = action;

    switch (action.type) {
        case types.INVESTOR_TEST_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
                fetchingSubmit: false,
                questions: [],
            };
        case types.INVESTOR_TEST_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                questions,
            };
        case types.INVESTOR_TEST_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
                questions: [],
            };

        case types.INVESTOR_TEST_SEND_REQUEST:
            return {
                ...state,
                expired: false,
                fetchingSubmit: true,
                investorProfile: null,
                testUpdateMessage: null,
            };
        case types.INVESTOR_TEST_SEND_SUCCESS:
            return {
                ...state,
                fetchingSubmit: false,
                investorProfile,
                testUpdateMessage,
            };
        case types.INVESTOR_TEST_SEND_FAILURE:
            return {
                ...state,
                fetchingSubmit: false,
                investorProfile: null,
                testUpdateMessage: null,
            };

        case types.FIRST_INVESTOR_TEST:
            return {
                ...state,
                firstTest: true,
            };

        case types.INVESTOR_PROFILE_READ_REQUEST:
        case types.ACCOUNTS_ADD_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
                investorProfile: null,
                lastTestDate: null,
                ...accountData,
            };
        case types.INVESTOR_PROFILE_READ_SUCCESS:
            return {
                ...state,
                fetching: false,
                investorProfile,
                lastTestDate,
                expired,
            };
        case types.INVESTOR_PROFILE_READ_FAILURE:
        case types.ACCOUNTS_ADD_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
                investorProfile: null,
                lastTestDate: null,
                accountData: null,
            };

        case types.DASHBOARD_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
                accountsOfficer: null,
                deposits: null,
                fci: null,
                bac: null,
                route: null,
                accountData: null,
            };
        case types.DASHBOARD_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                accountsOfficer,
                deposits,
                fci,
                bac,
                route: "/holdings",
            };
        case types.DASHBOARD_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
                accountsOfficer: null,
                deposits: null,
                fci: null,
                bac: null,
                route: null,
            };

        case types.ACCOUNT_OFFICER_CONTACT_REQUEST:
            return {
                ...state,
                fetchingSubmit: true,
            };
        case types.ACCOUNT_OFFICER_CONTACT_SUCCESS:
            return {
                ...state,
                fetchingSubmit: false,
            };
        case types.ACCOUNT_OFFICER_CONTACT_FAILURE:
            return {
                ...state,
                fetchingSubmit: false,
            };

        case types.ACCOUNTS_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
                accountsInfo: null,
                route: null,
                accountData: null,
            };
        case types.ACCOUNTS_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                accountsInfo,
                route: "/investmentFunds/listAccounts",
            };
        case types.ACCOUNTS_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
                accountsInfo: null,
                route: null,
            };

        case types.ACCOUNTS_ADD_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                expired,
            };
        case types.ACCOUNT_SET_ACCOUNT_DATA:
            return {
                ...state,
                accountData,
            };

        case types.ACCOUNTS_ADD_SEND_REQUEST:
            return {
                ...state,
                fetchingSubmit: true,
            };

        case types.ACCOUNTS_ADD_DELETE_DOC_FAILURE:
        case types.ACCOUNTS_ADD_SEND_SUCCESS:
            return {
                ...state,
                fetchingSubmit: false,
                fciAccount,
                bonusesAccount,
                accountData: null,
                firstTest: false,
            };
        case types.ACCOUNTS_ADD_SEND_FAILURE:
            return {
                ...state,
                fetchingSubmit: false,
            };
        case types.ACCOUNTS_ADD_UPLOAD_DOC_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "FETCHING", value: "", error: null, id: documentCode },
            };
        case types.ACCOUNTS_ADD_UPLOAD_DOC_SUCCESS:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "SUCCESS",
                    value: documentToUploadRequest,
                    error: null,
                    id: documentCode,
                },
            };
        case types.ACCOUNTS_ADD_UPLOAD_DOC_FAILURE:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "FAILURE",
                    value: "",
                    error: null,
                    id: null,
                },
            };
        case types.ACCOUNTS_ADD_DELETE_DOC_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },
            };

        case types.ACCOUNTS_DOCUMENT_UPLOAD_RESET:
            return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },
            };

        default:
            return state;
    }
};

export const actions = {
    investorTestPre: () => ({
        type: types.INVESTOR_TEST_PRE_REQUEST,
    }),

    investorTestSend: (params) => ({
        type: types.INVESTOR_TEST_SEND_REQUEST,
        params,
    }),

    firstInvestorTest: () => ({
        type: types.FIRST_INVESTOR_TEST,
    }),

    investorProfileRead: () => ({
        type: types.INVESTOR_PROFILE_READ_REQUEST,
    }),

    dashboardPre: () => ({
        type: types.DASHBOARD_PRE_REQUEST,
    }),

    accountOfficerContact: (params) => ({
        type: types.ACCOUNT_OFFICER_CONTACT_REQUEST,
        params,
    }),

    listAccounts: () => ({
        type: types.ACCOUNTS_LIST_REQUEST,
    }),

    addAccountPre: () => ({
        type: types.ACCOUNTS_ADD_PRE_REQUEST,
    }),

    setAccountData: (accountData) => ({
        type: types.ACCOUNT_SET_ACCOUNT_DATA,
        accountData,
    }),

    addAccountSend: (params) => ({
        type: types.ACCOUNTS_ADD_SEND_REQUEST,
        params,
    }),

    downloadAccountTerms: () => ({
        type: types.DOWNLOAD_ACCOUNT_TERMS_REQUEST,
    }),

    accountDocumentUpload: (documentToUpload) => ({
        type: types.ACCOUNTS_ADD_UPLOAD_DOC_REQUEST,
        documentToUpload,
        documentCode: documentToUpload.uploaderRequestId,
    }),

    accountDocumentDelete: (documentId) => ({
        type: types.ACCOUNTS_ADD_DELETE_DOC_REQUEST,
        documentId,
    }),

    resetDocumentToUploadRequest: () => ({
        type: types.ACCOUNTS_DOCUMENT_UPLOAD_RESET,
    }),
};

export const selectors = {
    getFetching: ({ investmentfunds }) => investmentfunds.fetching,
    getFetchingSubmit: ({ investmentfunds }) => investmentfunds.fetchingSubmit,
    getQuestions: ({ investmentfunds }) => investmentfunds.questions,
    getInvestorProfile: ({ investmentfunds }) => investmentfunds.investorProfile,
    getLastTestDate: ({ investmentfunds }) => investmentfunds.lastTestDate,
    getExpired: ({ investmentfunds }) => investmentfunds.expired,
    getAccountsOfficer: ({ investmentfunds }) => investmentfunds.accountsOfficer,
    getDeposits: ({ investmentfunds }) => investmentfunds.deposits,
    getFci: ({ investmentfunds }) => investmentfunds.fci,
    getBac: ({ investmentfunds }) => investmentfunds.bac,
    getAccountsInfo: ({ investmentfunds }) => investmentfunds.accountsInfo,
    getAccountData: ({ investmentfunds }) => investmentfunds.accountData,
    getRoute: ({ investmentfunds }) => investmentfunds.route,
    getFirstTest: ({ investmentfunds }) => investmentfunds.firstTest,
    getTestUpdateMessage: ({ investmentfunds }) => investmentfunds.testUpdateMessage,
};
